import React, { useEffect, useState } from 'react';
import axios from 'axios';

const RewardList = () => {
  const [rewards, setRewards] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    Promise.all([
      axios.get('https://loyaltyprogram.navalsupermart.com/api/rewards.php'),
      axios.get('https://loyaltyprogram.navalsupermart.com/api/customers.php')
    ])
      .then(([rewardsRes, customersRes]) => {
        if (Array.isArray(rewardsRes.data)) {
          setRewards(rewardsRes.data);
        } else {
          setError('Unexpected rewards format');
        }

        if (Array.isArray(customersRes.data)) {
          setCustomers(customersRes.data);
        }

        setLoading(false);
      })
      .catch(err => {
        console.error('Error loading data:', err);
        setError('Failed to load data');
        setLoading(false);
      });
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this reward?")) return;
    try {
      await axios.delete(`https://loyaltyprogram.navalsupermart.com/api/rewards.php?id=${id}`);
      setRewards(rewards.filter(r => r.id !== id));
    } catch (err) {
      console.error('Delete failed', err);
      alert('Failed to delete reward');
    }
  };

  const handleRedeem = async (rewardId) => {
    if (!selectedCustomer) {
      alert("Please select a customer first.");
      return;
    }

    if (!window.confirm("Redeem this reward for the selected customer?")) return;

    try {
      const res = await axios.post('https://loyaltyprogram.navalsupermart.com/api/redeem_reward.php', {
        reward_id: rewardId,
        customer_id: selectedCustomer
      });
      alert(res.data.message || 'Reward redeemed successfully!');
    } catch (err) {
      console.error('Redeem failed', err);
      alert('Failed to redeem reward');
    }
  };

  if (loading) return <p>Loading rewards...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div>
      <h2>Reward List</h2>

      <label>
        Select Customer:{' '}
        <select value={selectedCustomer} onChange={e => setSelectedCustomer(e.target.value)}>
          <option value="">-- Choose customer --</option>
          {customers.map(c => (
            <option key={c.id} value={c.id}>
              {c.name} ({c.points_balance} pts)
            </option>
          ))}
        </select>
      </label>

      <table border="1" cellPadding="8" style={{ marginTop: '1em' }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Reward</th>
            <th>Points</th>
            <th>Description</th>
            <th>Discount (₱)</th>
            <th>Expiry</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {rewards.length === 0 ? (
            <tr><td colSpan="7">No rewards found.</td></tr>
          ) : (
            rewards.map((reward, index) => (
              <tr key={reward.id || index}>
                <td>{reward.id}</td>
                <td>{reward.name}</td>
                <td>{reward.points}</td>
                <td>{reward.description}</td>
                <td>{reward.discount_value ? `₱${parseFloat(reward.discount_value).toFixed(2)}` : '—'}</td>
                <td>{reward.expiry_date || 'None'}</td>
                <td>
                  <button onClick={() => handleDelete(reward.id)}>Delete</button>{' '}
                  <button onClick={() => handleRedeem(reward.id)}>Redeem</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RewardList;
